import {evolve} from 'ramda';
import {replace} from 'utils/objects';
import initState from './state';

export const parseUrlQuery = query => {
	const vals = evolve({trashed: v => v === 'true'}, query);
	return replace(vals, initState.tagsQuery);
};
